import { Box, Typography, Grid, Stack } from '@mui/material';
import { HomeownerPortalWrapper } from '../components/homeowner-portal-wrapper';
import { homeownerPortalTheme } from '../styles/homeowner-portal-theme';
import learnMoreImage from '../../../assets/homeowner-portal/about_my_home_hero.webp';
import { CareTips } from './care-tips';
import { HeroSection } from '../components';
import { PreferredVendors } from './preferred-vendors';
import { MyHomeOptionsButton } from './my-home-options';
import { ContractButton } from './contract-button';
import { SitePlanButton } from './site-plan-button';

export const LearnMoreAboutMyHome = () => {
  return (
    <HomeownerPortalWrapper title="Learn More About My Home">
      <Box sx={{ flex: 1 }}>
        <HeroSection
          image={learnMoreImage}
          title="Learn More About My Home"
          subtitle="All the information you need for your new home"
          variant="small"
          backgroundPosition="0 10%"
        />

        <Box sx={{ flex: 1, py: { xs: 4, md: 6 }, px: { xs: 2, md: 4 } }}>
          <Grid container spacing={4} sx={{ mb: 4 }}>
            <Grid item xs={12} md={8}>
              <Typography
                variant="body1"
                sx={{
                  maxWidth: '1200px'
                }}
              >
                You can access your contract, site plan, and selected home options at any
                time—whether you're in the middle of the build process or already settled into your
                new home. Everything is stored in one convenient place, so you can reference
                important details whenever you need them, from reviewing your lot layout to
                confirming your interior selections.
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
                <ContractButton />
                <SitePlanButton />
                <MyHomeOptionsButton />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            backgroundColor: homeownerPortalTheme.palette.backgroundBlue.main,
            py: { xs: 2, md: 4 },
            px: { xs: 2, md: 4 }
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={7} mx={8}>
              <Typography variant="h4">Quick Access to Your Home's Vendors</Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3
                }}
              >
                Need to find your plumber, electrician, or HVAC contact fast? We've made it simple.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 3
                }}
              >
                Just scan the QR code located on your breaker panel to instantly access a list of
                designated vendors for your home. Whether you're scheduling a service, reporting an
                issue, or simply want to know who to call, everything you need is right at your
                fingertips—anytime you need it.
              </Typography>

              <Typography variant="body1">
                It's our way of making homeownership just a little easier.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box p={3}>
        <Stack spacing={2}>
          <PreferredVendors />
          <CareTips />
        </Stack>
      </Box>
    </HomeownerPortalWrapper>
  );
};
